import { SelectOption } from '../../models/SelectOption';

export enum FeeDesignationsSearchColumns {
  Description = "Description",
  UTBMS = "UTBMS",
  UTBMS_Activity = "UTBMSActivity"
};

export const AvailableFeeDesignationsSearchColumns: Array<SelectOption> = [
  { text: "Description", value: "Description" },
  { text: "UTBMS", value: "UTBMS" },
  { text: "UTBMS Activity", value: "UTBMS_Activity" }  
];